export default __webpack_public_path__ + "static/media/logo.c3e23f0e.gif";